import { cn } from 'cn';
import { type PropsWithChildren } from 'react';

type P = PropsWithChildren<{
  readonly id?: string;
}> &
  ComponentStyling;

export const Hint = ({ children, className, id, style }: P) => (
  <small
    className={cn('text-sm text-tiga-text-lighter italic', className)}
    id={id}
    style={style}
  >
    {children}
  </small>
);
